//Sans cette déclaration, le documentMode n'existe pas pour TS
declare global {
  interface Document {
    documentMode?: any;
  }
}

export class DetectBrowser {
  public static isInternetExplorer(): boolean{
    return (navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/common/browser/detect-browser.ts